let _decoder;
let _facesCount;
let _facesRead;
let _overReadLength;
let _unparsedTail;

export default {
  init(facesCount = null) {
    _decoder = new TextDecoder();
    _facesCount = facesCount;
    _facesRead = 0;
    _overReadLength = 0;
    _unparsedTail = "";
  },

  decodeASCII(dataChunk, buffer) {
    const textChunk = _unparsedTail + _decoder.decode(dataChunk, {stream: true});
    const patternFace = /facet([\s\S]*?)endfacet/g;

    const patternFloat = /[\s]+([+-]?(?:\d*)(?:\.\d*)?(?:[eE][+-]?\d+)?)/.source;
    const patternVertex = new RegExp( "vertex" + patternFloat + patternFloat + patternFloat, "g" );
    const patternNormal = new RegExp( "normal" + patternFloat + patternFloat + patternFloat, "g" );

    let normalX = 0;
    let normalY = 0;
    let normalZ = 0;

    let result;
    let unreadPosition = 0;
    while ( ( result = patternFace.exec( textChunk ) ) !== null) {
      unreadPosition = patternFace.lastIndex;

      let vertexCountPerFace = 0;
      let normalCountPerFace = 0;

      const text = result[ 0 ];
      while ( ( result = patternNormal.exec( text ) ) !== null ) {

        normalX = parseFloat( result[ 1 ] );
        normalY = parseFloat( result[ 2 ] );
        normalZ = parseFloat( result[ 3 ] );
        normalCountPerFace ++;

      }

      while ( ( result = patternVertex.exec( text ) ) !== null ) {
        const vertexX = parseFloat( result[ 1 ]);
        const vertexY = parseFloat( result[ 2 ]);
        const vertexZ = parseFloat( result[ 3 ]);

        buffer.push(buffer.VERTICES, vertexX);
        buffer.push(buffer.VERTICES, vertexY);
        buffer.push(buffer.VERTICES, vertexZ);

        buffer.push(buffer.NORMALS, normalX);
        buffer.push(buffer.NORMALS, normalY);
        buffer.push(buffer.NORMALS, normalZ);

        vertexCountPerFace ++;
      }

      // every face have to own ONE valid normal
      if ( normalCountPerFace !== 1 ) {
        throw new Error( "ExternalLoader.StlLoader: Something isn't right with the normal of face number " + _facesRead);
      }

      // each face have to own THREE valid vertices

      if ( vertexCountPerFace !== 3 ) {
        throw new Error ("ExternalLoader.StlLoader: Something isn't right with the vertices of face number " + _facesRead);
      }

      _facesRead++;
    }
    _unparsedTail = textChunk.slice(unreadPosition);
  },

  decodeBinary(dataChunk, dataSize, buffer) {
    const faceLength = 12 * 4 + 2;
    const view = new DataView(dataChunk.buffer);

    let pos = _overReadLength
    while (pos < dataSize && _facesRead < _facesCount) {
      const normalX = view.getFloat32( pos, true );
      const normalY = view.getFloat32( pos + 4, true );
      const normalZ = view.getFloat32( pos + 8, true );

      for ( let i = 1; i <= 3; i ++ ) {
        const vertexstart = pos + i * 12;
        const vertexX = view.getFloat32( vertexstart, true );
        const vertexY = view.getFloat32( vertexstart + 4, true );
        const vertexZ = view.getFloat32( vertexstart + 8, true );

        buffer.push(buffer.VERTICES, vertexX);
        buffer.push(buffer.VERTICES, vertexY);
        buffer.push(buffer.VERTICES, vertexZ);

        buffer.push(buffer.NORMALS, normalX);
        buffer.push(buffer.NORMALS, normalY);
        buffer.push(buffer.NORMALS, normalZ);
      }

      pos += faceLength;
      _facesRead++;
    }

    _overReadLength = pos - dataSize;
  },
}

export class Buffer {
  constructor() {
    this.VERTICES = 0;
    this.NORMALS = 1;

    this.store = [];
  }

  push(bufferType, value) {
    throw new Error("Buffer is an abstract class. Reimplement push function." + bufferType + value);
  }
}
